import { Injectable } from '@angular/core';
import { Http, Headers , RequestOptions } from '@angular/http';
import { Events } from 'ionic-angular';

import { AuthServiceProvider } from '../auth-service/auth-service';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';

/*
  Generated class for the EntidadServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class EntidadServiceProvider {
  
  serverServicios = "";
  headers = new Headers();
  headersPost:any;
  idtentidad:any;

  constructor(public http: Http, public autorizacionService: AuthServiceProvider, public events: Events) {
    //this.serverServicios = "http://localhost:3000";
    this.serverServicios = "http://165.227.106.28:3000";

    this.headers.append('Authorization', this.autorizacionService.token);

    this.headersPost = new Headers({ 'Content-Type': 'application/json' });
    this.headersPost.append('Authorization', this.autorizacionService.token);
  }

  getResults(keyword:string) {
    return this.http.get(this.serverServicios + '/posentidad/filtro/1/'+this.idtentidad+'/'+keyword, {headers: this.headers})
      .map(result =>{
        console.log(result.json())
          return result.json()
        });
  }

  getEntidad(idtentidad)
  {
    return new Promise(resolve => {
      this.http.get(this.serverServicios + '/posentidad/1/'+idtentidad+'/0', {headers: this.headers})
        .map(res => res.json()).subscribe(data => {
          resolve(data);
        }, (err) => {
          this.events.publish('user:validartoken', err._body);
        });
    }); 
  }

  guardar(data)
  {
    return new Promise((resolve, reject) => {
      this.http.post(this.serverServicios + '/posentidad', JSON.stringify(data), { headers: this.headersPost })
        .toPromise().then((response) => {
          resolve(response.json());
        }).catch((error) =>{

          this.events.publish('user:validartoken', error._body);
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/entidad-service/entidad-service.ts